import { Wind, Gauge, Droplets, Flame, Sun, Snowflake } from "lucide-react";
import { Overline, Reveal, MaskLine } from "./shared";
import { useLang } from "@/i18n";

const icons = [Wind, Gauge, Droplets, Flame, Sun, Snowflake];

export default function Quality() {
  const { t } = useLang();
  const tests = t("quality.tests");

  return (
    <section id="quality" className="bg-olive py-24 text-cream lg:py-32" data-testid="quality-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <Overline className="!text-mustard">{t("quality.overline")}</Overline>
        <div className="mt-4 flex flex-wrap items-end justify-between gap-6">
          <h2 className="max-w-xl font-serif text-4xl font-medium leading-tight tracking-tight sm:text-5xl">
            <MaskLine>{t("quality.title1")}</MaskLine>
            <MaskLine delay={0.12}>
              <span className="italic text-mustard">{t("quality.title2")}</span>
            </MaskLine>
          </h2>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm font-light leading-relaxed text-cream/70">
              {t("quality.side")}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden border border-cream/15 bg-cream/15 sm:grid-cols-2 lg:grid-cols-3">
          {tests.map((test, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={test.title} delay={i * 0.06} className="group bg-olive p-8 transition-colors duration-500 hover:bg-ink">
                <div data-testid={`quality-test-${i + 1}`}>
                  <Icon className="h-6 w-6 text-mustard transition-transform duration-500 group-hover:-translate-y-1" />
                  <h3 className="mt-5 font-serif text-xl font-semibold tracking-tight">{test.title}</h3>
                  <p className="mt-3 text-sm font-light leading-relaxed text-cream/70">{test.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
